export default __webpack_public_path__ + "static/media/ic_delete.9f476544.svg";